const $$splitComponentImporter = () => import('/src/src/routes/_session/password_reset/$token.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_session/password_reset/$token")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Password Reset",
      description: "Page title"
    })
  }
});